import { useRef } from 'react';
import { useDialogContainer } from '../../common/hooks/use-dialog-container';
import Button from '../button/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip/tooltip';
import type { DynamicFormButtonSetting } from './dynamic-form.interfaces';

const MAX_DISPLAY_LENGTH = 24;
const TRUNCATED_LENGTH = 21;

interface DynamicFormButtonProps {
  button: DynamicFormButtonSetting;
  readOnly?: boolean;
  fullWidth?: boolean;
}

const DynamicFormButton = ({ button, readOnly, fullWidth = false }: DynamicFormButtonProps) => {
  const tooltipTriggerRef = useRef<HTMLButtonElement>(null);
  const tooltipContainer = useDialogContainer(tooltipTriggerRef);

  const fullText = button.text;
  const showTooltip = fullText.length > MAX_DISPLAY_LENGTH;
  const displayText = showTooltip ? `${fullText.substring(0, TRUNCATED_LENGTH)}...` : fullText;
  const disabled = button.disabled === undefined ? readOnly : button.disabled;

  return (
    <Tooltip>
      <TooltipTrigger
        ref={tooltipTriggerRef}
        disabled={!showTooltip}
        render={
          <Button
            fullWidth={fullWidth}
            htmlType={button.htmlType}
            type={button.type}
            variant={button.variant}
            classNames={button.className}
            disabled={disabled}
            hidden={button.hidden}
            onClick={button.onClick}
          >
            {displayText}
          </Button>
        }
      />
      <TooltipContent className="max-w-none whitespace-nowrap" container={tooltipContainer}>
        {fullText}
      </TooltipContent>
    </Tooltip>
  );
};

export default DynamicFormButton;
